import { Component } from "@angular/core";

@Component({
    selector: 'message-dialog',
    templateUrl: 'dialog.html',
})
export class MessageDialogComponent {
}